import { render, staticRenderFns } from "./buyerBenefitCardDetail.vue?vue&type=template&id=82c2cbd4&scoped=true&"
import script from "./buyerBenefitCardDetail.vue?vue&type=script&lang=js&"
export * from "./buyerBenefitCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./buyerBenefitCardDetail.vue?vue&type=style&index=0&id=82c2cbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c2cbd4",
  null
  
)

export default component.exports